var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("ADICIONAR PRODUTOS")]),_c('AddStockUpdate')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }